import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

const getFeatureFlags = async () => {
  const response = await fetchWrapper(hcUrlV3('/feature_flags'), buildOpts());
  return handleResponse(response);
};

export { getFeatureFlags };
